//【厚労省】平成30年就労条件総合調査「結果の概況 退職給付（一時金・年金）の支給実態」
// 大学・大学院卒 平成30年調査計
// 第 24 表 退職給付（一時金・年金）制度の形態別定年退職者１人平均退職給付額
// （勤続 20 年以上かつ 45 歳以上の定年退職者）
// 42歳 1,267
// 47歳 1,395
// 52歳 1,794
// 57歳以上 1,983
// 定年 1,983
export default {
    18:0,
    19:0,
    20:0,
    21:0,
    22:0,
    23:0,
    24:0,
    25:0,
    26:0,
    27:0,
    28:0,
    29:0,
    30:0,
    31:0,
    32:0,
    33:0,
    34:0,
    35:0,
    36:0,
    37:0,
    38:0,
    39:0,
    40:0,
    41:0,
    42:1267,
    43:1267,
    44:1267,
    45:1267,
    46:1267,
    47:1395,
    48:1395,
    49:1395,
    50:1395,
    51:1395,
    52:1794,
    53:1794,
    54:1794,
    55:1794,
    56:1794,
    57:1983,
    58:1983,
    59:1983,
    60:1983,
    61:1983,
    62:1983,
    63:1983,
    64:1983,
    65:1983,
    66:1983,
    67:1983,
    68:1983,
    69:1983,
    70:1983,
    71:1983,
    72:1983,
    73:1983,
    74:1983,
    75:1983,
    76:1983,
    77:1983,
    78:1983,
    79:1983,
    80:1983,
    81:1983,
    82:1983,
    83:1983,
    84:1983,
    85:1983,
    86:1983,
    87:1983,
    88:1983,
    89:1983,
    90:1983,
}